import React from "react";
import { Header } from "./Components/Hdr/Header";
import "./App.css";
import { ThemeContext } from "./Context/theme";
import { About } from "./Components/Abt/About";
import Aos from "aos";
import "aos/dist/aos.css";
// import { Techstacks } from "./Components/About/Techstacks";
import { Github } from "./Components/Abt/Github";
import { Projects } from "./Components/prj/Projects";
import { Contact } from "./Components/Cnt/Contact.jsx";
import { Footer } from "./Components/Ftr/Footer";
import { ScrollToTop } from "./Components/ScrollToTop/ScrollToTop";


export default function App() {
  const [{ themename }] = React.useContext(ThemeContext);
  React.useEffect(() => {
    Aos.init({ duration: 1500 });
  }, []);
  return (
    <>
      <div id="top" className={`${themename} app`} >
        <div id="headishilajit" style={{  position: "fixed",  zIndex: "99",width:"100%",height:"auto",scrollBehavior:"smooth" }}>
          <section id="#home" >
            <Header  />
          </section>
        </div>

        <div id="total" style={ { paddingTop:"3%" }}>
          <main style={ { marginTop:"5%" }}>
            <About />
            <Github />
            <section id="#projects">
              <Projects />
            </section>
            <section id="#contact">
              <Contact />
            </section>
          </main>

          <Footer />
          <ScrollToTop />
        </div>

      </div>
    </>

  );
}
